import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateEntitiesParams } from 'domain/models';
import { UpdateEntitiesUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateEntities implements UpdateEntitiesUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UpdateEntitiesUseCaseInterface.Result>,
  ) {}

  async execute(
    params: UpdateEntitiesUseCaseInterface.Params,
  ): Promise<UpdateEntitiesUseCaseInterface.Result> {
    const { id, address, ...rest } = params;

    const body: UpdateEntitiesParams = { ...rest };

    if (address) {
      const { cityId, ...restAddress } = address;
      body.address = { ...restAddress, cityId: Number(cityId) };
    }

    const httpResponse = await this.httpClient.request({
      method: 'patch',
      url: `${this.url}/${id}`,
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
